const translation = {
  MENU_TITLE: 'Mi panel',
  GENERAL_ERROR: 'Ocurrió un error',
  TRY_AGAIN: 'Vuelve a intentarlo',
  SEARCH_LABEL: '¿Qué buscas en tu panel?',
  INTERNET_CONNECTION_ERROR: 'Ocurrió un error de conexión',
  RELOAD_PAGE: 'Recargar la página',
};

export default translation;
